var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTlmCapabilityImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.25 103.125H75L62.5 87.5H12.5C10.8424 87.5 9.25268 88.1585 8.08058 89.3306C6.90848 90.5027 6.25 92.0924 6.25 93.75V187.5C6.25 189.158 6.90848 190.747 8.08058 191.919C9.25268 193.092 10.8424 193.75 12.5 193.75H156.25C157.908 193.75 159.497 193.092 160.669 191.919C161.842 190.747 162.5 189.158 162.5 187.5V109.375C162.5 107.717 161.842 106.128 160.669 104.956C159.497 103.783 157.908 103.125 156.25 103.125Z",
    fill: "#FFD55D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 193.75H156.25C157.908 193.75 159.497 193.092 160.669 191.919C161.842 190.747 162.5 189.158 162.5 187.5V121.875H18.75V193.75Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 156.25H68.75V181.25H31.25V156.25Z",
    fill: "#FFECAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.625 156.25H59.375V146.875C59.375 144.389 58.3873 142.004 56.6291 140.246C54.871 138.488 52.4864 137.5 50 137.5C47.5136 137.5 45.129 138.488 43.3709 140.246C41.6127 142.004 40.625 144.389 40.625 146.875V156.25H34.375V146.875C34.375 142.731 36.0212 138.757 38.9515 135.826C41.8817 132.896 45.856 131.25 50 131.25C54.144 131.25 58.1183 132.896 61.0485 135.826C63.9788 138.757 65.625 142.731 65.625 146.875V156.25Z",
    fill: "#D7D7D8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.375 146.875V156.25H65.625V146.875C65.62 142.733 63.9722 138.761 61.0431 135.832C58.1139 132.903 54.1425 131.255 50 131.25V137.5C52.4864 137.5 54.871 138.488 56.6291 140.246C58.3873 142.004 59.375 144.389 59.375 146.875Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.375 175C34.375 175.829 34.7042 176.624 35.2903 177.21C35.8763 177.796 36.6712 178.125 37.5 178.125H68.75V156.25H34.375V175Z",
    fill: "#FFF3C9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.5 84.375H121.875L109.375 96.875V84.375H93.75C92.0924 84.375 90.5027 83.7165 89.3306 82.5444C88.1585 81.3723 87.5 79.7826 87.5 78.125V12.5C87.5 10.8424 88.1585 9.25268 89.3306 8.08058C90.5027 6.90848 92.0924 6.25 93.75 6.25H187.5C189.158 6.25 190.747 6.90848 191.919 8.08058C193.092 9.25268 193.75 10.8424 193.75 12.5V78.125C193.75 79.7826 193.092 81.3723 191.919 82.5444C190.747 83.7165 189.158 84.375 187.5 84.375Z",
    fill: "#FFECAE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.875 15.625H165.625V40.625H96.875V15.625Z",
    fill: "#5499C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 165.625H53.125V171.875H46.875V165.625Z",
    fill: "#D7D7D8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M96.875 50H184.375V75H96.875V50Z",
    fill: "#5499C9"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M116.541 19.6655L112.5 23.7062L108.46 19.6655L104.041 24.0843L108.082 28.1249L104.041 32.1655L108.46 36.5843L112.5 32.5437L116.541 36.5843L120.96 32.1655L116.919 28.1249L120.96 24.0843L116.541 19.6655Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M135.291 19.6655L131.25 23.7062L127.21 19.6655L122.791 24.0843L126.832 28.1249L122.791 32.1655L127.21 36.5843L131.25 32.5437L135.291 36.5843L139.71 32.1655L135.669 28.1249L139.71 24.0843L135.291 19.6655Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.041 19.6655L150 23.7062L145.96 19.6655L141.541 24.0843L145.582 28.1249L141.541 32.1655L145.96 36.5843L150 32.5437L154.041 36.5843L158.46 32.1655L154.419 28.1249L158.46 24.0843L154.041 19.6655Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.541 54.0405L112.5 58.0812L108.46 54.0405L104.041 58.4593L108.082 62.4999L104.041 66.5405L108.46 70.9593L112.5 66.9187L116.541 70.9593L120.96 66.5405L116.919 62.4999L120.96 58.4593L116.541 54.0405Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.291 54.0405L131.25 58.0812L127.21 54.0405L122.791 58.4593L126.832 62.4999L122.791 66.5405L127.21 70.9593L131.25 66.9187L135.291 70.9593L139.71 66.5405L135.669 62.4999L139.71 58.4593L135.291 54.0405Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.041 54.0405L150 58.0812L145.96 54.0405L141.541 58.4593L145.582 62.4999L141.541 66.5405L145.96 70.9593L150 66.9187L154.041 70.9593L158.46 66.5405L154.419 62.4999L158.46 58.4593L154.041 54.0405Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.21 58.4593L172.791 54.0405L168.75 58.0812L164.71 54.0405L160.291 58.4593L164.332 62.4999L160.291 66.5405L164.71 70.9593L168.75 66.9187L172.791 70.9593L177.21 66.5405L173.169 62.4999L177.21 58.4593Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M146.875 178.125H153.125V184.375H146.875V178.125Z",
    fill: "#5A5B5D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 178.125H140.625V184.375H103.125V178.125Z",
    fill: "#5A5B5D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.875 165.625H153.125V171.875H146.875V165.625Z",
    fill: "#5A5B5D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.125 165.625H140.625V171.875H103.125V165.625Z",
    fill: "#5A5B5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlmCapabilityImage);
export default __webpack_public_path__ + "static/media/tlm-capability-image.434cd890.svg";
export { ForwardRef as ReactComponent };